import { useAuth } from '@clerk/clerk-react';
import useSWR from 'swr';
import { spacesApi } from '@/lib/api';
import { EXPENSES_PAGE_SIZE, expenseBounds } from '@/lib/spaces/expenses';
import { VOLATILE_SWR_OPTIONS, useAuthedFetcher } from './swrConfig';

export function useSpaceExpensesPage(spaceId: string, period: string, filter: string, offset: number, limit = EXPENSES_PAGE_SIZE) {
  const { userId } = useAuth();
  const fetch = useAuthedFetcher();
  return useSWR(userId ? ['space-expenses-page', userId, spaceId, period, filter, offset, limit] : null,
    () => fetch((token) => spacesApi.expensesOverview(token, spaceId, { ...expenseBounds(period), filter, limit: String(limit), offset: String(offset) })),
    { ...VOLATILE_SWR_OPTIONS, shouldRetryOnError: false });
}
